import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomeSalesOrderDefaults'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomeSalesOrderDefaultsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomeSalesOrderDefaultsStore",
			variables: false,
		})
	}
}

export async function load_HomeSalesOrderDefaults(params) {
  await initClient()

	const store = new HomeSalesOrderDefaultsStore()

	await store.fetch(params)

	return {
		HomeSalesOrderDefaults: store,
	}
}
